import Wrapper from "../../../layout/Wrapper";
import AppContentComponent from "../../../screens/settings/app-control";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "App Control",
	description: "",
};

export default function AppControl() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<AppContentComponent />
		</Wrapper>
	);
}